import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Stack } from '@mui/material';
import {Grid, Button, Box} from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import Radio from '@mui/material/Radio';
import axios from 'axios';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import {API_URL} from '../utils/EnvVars';
import Alert from '../components/Alert';
import 'font-awesome/css/font-awesome.min.css';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const childRefAlert = React.useRef();

  const [open, setOpen] = React.useState(false); 
  const [rows, setRows] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState(0);
  const [dataLoading, setDataLoading] = React.useState(false);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [alertMessage, setAlertMessage] = React.useState("");

  //const [dataLoading, setDataLoading] = React.useState(true);
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
      if(props.fetch===true){
        props.fetchDetail(rows[obj.id-1]);
        setOpen(false);
      }else{
			  addMember(rows[obj.id-1]);
      }  
		}
	}

  function search(){
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}

  React.useEffect(() => {		
		if(open && props.userObj){
			getApiData();
		}
	}, [open,props.userObj,filter]);

	async function getApiData(){ 

		  let apiUrl=API_URL+'/crm-list-crmusers?keyword='+keyword+'&sorting=fullName';
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': props.userObj.registerId,
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
      setDataLoading(true);
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.data && response.data.responseTxt==="success"){  
				 	setRows(response.data.list);				 				
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';
				}
			}).catch((error) => {
				  setSeverityAlert("error");
				  childRefAlert.current.handleClickOpen();
				  setAlertMessage(""+error);			
				  return false;
		  	})	
	}

  function addMember(myMemObj){

    if(props.relatedToId && myMemObj && props.userObj.token){
      let axiosHeader = {
          headers: {
            'Content-Type': 'multipart/mixed',
            'device': 'web',
            'registerId': props.userObj.registerId,
            'uid': props.userObj.loginId,
            'fullName': props.userObj.fullName,
            'token': props.userObj.token
        }
      }; 

      const data = new FormData();
      data.append('relatedTo', props.relatedTo);
      data.append('relatedToId', props.relatedToId);
      data.append('proId', myMemObj.autoId);
      data.append('fullName', myMemObj.fullName);
         
      axios.post(API_URL+'/crm-create-members-xxxx', data, axiosHeader)
        .then((response) => {
          ///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
        if(response.data.responseTxt==="success"){
          props.updatedList(response.data.list);
          setSeverityAlert("success");
          setAlertMessage("Member has been added.");
          childRefAlert.current.handleClickOpen();
          setOpen(false);
          return false;

        }else if(response.data.responseTxt==="alreadyAdded"){
          setSeverityAlert("error");
          setAlertMessage("Member was added earlier.");
          childRefAlert.current.handleClickOpen();
          setOpen(false);
          return false;

        }else{
          setSeverityAlert("error");
          setAlertMessage("Member could not be added.");
          childRefAlert.current.handleClickOpen();
          return false;

        }
      })
        .catch((error) => {
          setSeverityAlert("error");
          setAlertMessage(""+error);
          childRefAlert.current.handleClickOpen();
          return false;
        })	
    }		
    
  }

  return (
    <>
      <Dialog fullWidth style={{margin:5}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-15px'}} onClose={handleClose}>Agents</DialogTitle>
        {dataLoading?<LinearProgress />:null}
          <DialogContent >
            <Grid item md={12} xs={12}  >
                  
                  <Box mt={1} mb={1} >
                      <Grid container spacing={2}>
                        <Grid item md={12} xs={12} >
                          <FormControl style={{width:150,marginRight:60,float:'left'}}>
                            <OutlinedInput 
                            id="keywordtxt"
                            placeholder="Search"
                            value={keyword}
                            onChange={event => setKeyword(event.target.value)}
                            onKeyPress={(event)=>{onEnter(event)}}
                            style={{width:200,height:40}}
                            endAdornment={
                              <InputAdornment position="end">
                              <SearchIcon />
                              </InputAdornment>
                            }
                            />
                          </FormControl>
                          <Button onClick={() => {search()}} style={{marginTop:4,float:'left',backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Search</Button>
                        </Grid>
                      </Grid>
                  </Box>

                  <Box>

                  <DataGrid
                    rows={rows}
                    columns={[
                      {
                        field: "Select",
                        headerName: "",
                        width: 90,
                        sortable: false,
                          renderCell: (cellValues) => {
                          return (
                            <Radio 
                            checked={cellValues.id === selectedRow}
                            value={cellValues.id}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': {cellValues} }}
                            />
                           )
                          }
                        },
                      { field: 'id', headerName: '#', width: 40 },                         
                      { field: 'fullName', headerName: 'Full Name', width: 250, renderCell: (params) =>  (
                        <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
                         ), },
                      { field: 'mobile', headerName: 'Mobile', width: 250 },   
                      { field: 'active', headerName: 'Active', width: 160 ,
                        renderCell: (cellValues) => {
                          return <span>{cellValues.row.active===1?<><i className="fa fa-check-square-o" style={{fontSize:15}} ></i></>:<><i className="fa fa-square-o" style={{fontSize:15}} ></i></>}</span>
                          },
                        }
                      
                      ]}
                    pageSize={50}
                    rowHeight={40}
                    rowsPerPageOptions={[50]}
                    style={{fontSize:12, height: 350, width: '100%'}}	
                    onRowClick={itm => selectRow(itm)}			
                    components={{
                      NoRowsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                        <span style={{color:'#FF0000',fontWeight:'bold'}}>No record found!</span>
                        </Stack>
                      )}}	
                  />
                  </Box>
            </Grid>
          </DialogContent>
      </Dialog>


      <Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} />


    </>
  );

});

export default CustomizedDialogs;